const useFilterItems = <T extends Record<string, any>>() => {
  const filter = (items: T[], value: string, keys: string[] = ['name']) => {
    const filterCallback = (item: T, mode: 'includes' | 'startsWith') => {
      return keys.some((key) => {
        return mode === 'includes'
          ? item[key].toLowerCase().includes(value.toLowerCase())
          : item[key].toLowerCase().startsWith(value.toLowerCase());
      });
    };

    const startsWithItems = items.filter((item) => filterCallback(item, 'startsWith'));
    const includesItems = items.filter((item) => filterCallback(item, 'includes'));

    return [...startsWithItems, ...includesItems.filter((item) => !startsWithItems.includes(item))];
  };

  return {
    filter,
  };
};

export default useFilterItems;
